export const EVENT_TYPES = {
    ONLINE: 'online',
    OFFLINE: 'offline',
};

export const LINK_TYPES = {
    OVERALL: 'overall',
    PER_EVENT: 'per_event',
};

export const PERIOD_TYPES = {
    SINGLE: 'single',
    MULTIPLE: 'multiple',
};

export const VIDEO_RECORD_TYPES = {
    COMMON: 'common',
    EACH_EVENT: 'each_event',
};

export const AUTOMATIC_PASS_AFTER_TYPES = {
    AFTER_ACCEPT_VISIT: 'after_accept_visit',
    AFTER_REVIEWING_VIDEOS: 'after_reviewing_videos',
};

export const EVENT_COVER_UPLOAD_KEY = 'cover';
export const MAX_EVENT_COVER_FILE_SIZE = 10;
export const MAX_EVENT_COVER_FILE_BYTES = MAX_EVENT_COVER_FILE_SIZE * 1024 * 1024; // 10 MB
export const ACCEPT_EVENT_COVER_TYPES = ['image/jpg', 'image/jpeg', 'image/png'];
export const BASE_MEDIA_LIBRARY_LINK = 'https://media.sberuniversity.online/media-link/virtschool/';
